import React from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';
import { useTheme } from '../../utils/theme';
import { useTranslation } from 'react-i18next';

interface ThemeToggleProps {
  className?: string;
}

/** 다크/라이트 전환 버튼. 상태는 localStorage(openflow.theme)에 저장된다. */
const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  const { t } = useTranslation();
  const { isDark, toggle } = useTheme();
  const Icon = isDark ? FiSun : FiMoon;
  return (
    <button
      type="button"
      onClick={toggle}
      className={`p-2 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 transition-colors ${className || ''}`}
      title={isDark ? t('layout:theme.toLight') : t('layout:theme.toDark')}
      aria-label={isDark ? t('layout:theme.toLight') : t('layout:theme.toDark')}
    >
      {/* @ts-ignore react-icons IconType 과 React 18 타입 불일치 회피 (CanvasToolbar 와 동일) */}
      <Icon size={18} />
    </button>
  );
};

export default ThemeToggle;
